<template>
  <div>
    <ul class="select-option" style="overflow: hidden">
      <li>
        <span class="select-title">事件ID：</span>
        <el-input v-model="caseId" placeholder="请输入事件ID" class="select-input" @keyup.enter.native="search" />
      </li>

      <li>
        <span class="select-title">受助人姓名：</span>
        <el-input v-model="realName" placeholder="受助人姓名" class="select-input" @keyup.enter.native="search" />
      </li>

      <li>
        <span class="select-title">受助人身份证号：</span>
        <el-input v-model="idCard" maxlength="18" placeholder="受助人身份证号" class="select-input" @keyup.enter.native="search" />
      </li>
      <li>
        <span class="select-title">处理人姓名：</span>
        <el-input v-model="handler" placeholder="请输入申请人姓名" class="select-input" @keyup.enter.native="search" />
      </li>
      <li>
        <span class="select-title">任务状态：</span>
        <el-cascader v-model="status" :options="taskStatusList" :props="taskStatusProps" class="select-input" clearable @change="taskStatusChange" />
      </li>
      <li>
        <span class="select-title">任务分配时间：</span>
        <el-date-picker v-model="startTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" />
      </li>

      <!-- <li>
        <span class="select-title">所属流程：</span>
        <el-cascader
          v-model="caseFlow"
          :options="processList"
          :props="taskStatusProps"
          class="select-input"
          clearable
          @change="processChange"
        />
      </li> -->
      <li>
        <span class="select-title">任务类型：</span>
        <el-cascader v-model="taskCode" :options="allTaskList" :props="taskStatusProps" class="select-input" clearable @change="allTaskChange" />
      </li>

      <li>
        <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      </li>
      <!-- <li /> -->

      <li style="display: block; width: 100%">
        <el-button
          type="primary"
          icon="iconfont icon-daochu"
          v-loading.fullscreen.lock="fullscreenLoading"
          element-loading-text="导出报表需要的时间较长，请勿关闭或刷新当前浏览器，请耐心等待下载完成！在等待下载期间你可以改用其他浏览器继续登录风控进行工作！"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          @click="exportCase"
        >
          导出
        </el-button>
        <el-button
          v-if="checkPermission('修改处理人', permList)"
          type="primary"
          icon="iconfont icon-biangeng"
          @click="onChangeCase"
        >
          修改处理人
        </el-button>
        <el-button type="primary" icon="iconfont icon-chakanxiangqing" @click="onSeeCase">
          查看详情
        </el-button>
      </li>
    </ul>

    <el-table
      ref="multipleTable"
      :data="tableData.records"
      border
      tooltip-effect="dark"
      style="width: 100%; margin-top: 15px"
      :row-style="rowStyle"
      :row-class-name="rowClassName"
      @selection-change="selectionChange"
      @row-click="rowClick"
    >
      <el-table-column label="序号" type="index" :index="indexMethod" width="50" align="center" />
      <el-table-column type="selection" width="60" align="center" />
      <el-table-column label="事件id" prop="caseId" width="150" align="center" />
      <el-table-column prop="reportTime" label="报案时间" width="180" align="center" />
      <el-table-column prop="startTime" label="任务开始时间" width="180" align="center" />
      <el-table-column prop="endTime" label="任务完成时间" width="180" align="center" />
      <el-table-column prop="recRealName" label="受助人姓名" align="center" width="120" show-overflow-tooltip />
      <el-table-column prop="productName" label="所属计划" align="center" width="200" show-overflow-tooltip />
      <el-table-column prop="taskFlowName" label="任务所属流程" align="center" width="200" show-overflow-tooltip />
      <el-table-column prop="caseParentFlowName" label="事件状态" align="center" show-overflow-tooltip />
      <el-table-column prop="caseFlowName" label="当前处理状态" align="center" width="200" show-overflow-tooltip />
      <el-table-column prop="status" label="任务状态" align="center" show-overflow-tooltip />
      <el-table-column prop="handler" label="处理人" align="center" width="150" show-overflow-tooltip />
    </el-table>
    <div style="text-align: center; margin-top: 25px">
      <el-pagination
        :page-size="tableData.size"
        :current-page="pageIndex"
        background
        layout="total,prev, pager, next, jumper"
        :total="tableData.total"
        @current-change="pageChange"
      />
    </div>

    <!-- 变更经办人-操作弹出窗 -->
    <el-dialog title="变更经办人" :visible.sync="dialogFormVisible" width="30%" custom-class="c-p">
      <el-tree :data="dialogData" :props="defaultProps" accordion @node-click="changeOperator" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'TaskAll',
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }
        ]
      },
      loading: true,
      accessRole: 'ACCESS_ALL',
      limit: 10,
      pageIndex: 1,
      caseId: '',
      handler: '',
      status: null,
      startTime: '',
      realName: '',
      idCard: '',
      caseFlow: '', // 所属流程（已废除）
      taskCode: '', // 任务类型

      optionProps: {
        expandTrigger: 'hover',
        emitPath: false,
        multiple: true,
        value: 'flowCode',
        label: 'name',
        children: 'children'
      },
      tableData: {},
      selectRows: [],
      dialogData: [],
      dialogFormVisible: false,
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      currentCode: '',
      formLabelWidth: '120px',
      taskStatusList: [],
      // 所属流程（已废除）
      processList: [
        { code: 101020, name: '【公估-回访】' },
        { code: 100020, name: '【初审回访客诉子任务】' },
        { code: 100513, name: '【缴费回访客诉子任务】' },
        { code: 100599, name: '【是否去调查子任务】' },
        { code: 103001, name: '【确认结果客诉子任务】' },
        { code: 101520, name: '【补资料回访子任务】' }
      ],

      // 任务类型
      allTaskList: [
        { code: 'T0002', name: '【公估-回访】' },
        { code: 'T0005', name: '【初审回访客诉子任务】' },
        { code: 'T0006', name: '【缴费回访客诉子任务】' },
        { code: 'T0007', name: '【是否去调查子任务】' },
        { code: 'T0008', name: '【确认结果客诉子任务】' },
        { code: 'T0009', name: '【补资料回访子任务】' },
        { code: 'T0010', name: '【初审补资料回访子任务】' },
        { code: 'T0011', name: '【公估公司子任务】' },
        { code: 'T0012', name: '【调查回访子任务】' }
      ],

      taskStatusProps: {
        expandTrigger: 'hover',
        emitPath: false,
        value: 'code',
        label: 'name',
        children: 'children'
      },

      // 全屏加载中状态
      fullscreenLoading: false
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    }),

    selectRowsId: function() {
      const idArr = []
      if (this.selectRows.length > 0) {
        this.selectRows.filter((item) => {
          idArr.push(item.userId)
        })
      }
      return idArr
    }
  },

  created() {
    // 通过缓存“currentTaskSearchData”存储筛选条件内容
    // const currentTaskSearchData = JSON.parse(
    //   localStorage.getItem('currentTaskSearchData')
    // )
    // if (currentTaskSearchData) {
    //   this.accessRole = currentTaskSearchData.accessRole
    //   this.limit = currentTaskSearchData.limit
    //   this.pageIndex = currentTaskSearchData.pageIndex
    //   this.caseId = currentTaskSearchData.caseId
    //   this.handler = currentTaskSearchData.handler
    //   this.status = currentTaskSearchData.status
    //   this.startTime = currentTaskSearchData.startTime
    //   this.realName = currentTaskSearchData.realName
    //   this.idCard = currentTaskSearchData.idCard
    //   this.caseFlow = currentTaskSearchData.caseFlow
    //   this.taskCode = currentTaskSearchData.taskCode
    // }

    const data = {
      accessRole: this.accessRole,
      limit: this.limit,
      page: this.pageIndex,
      caseId: this.caseId,
      handler: this.handler,
      status: this.status,
      startTime: this.startTime,
      realName: this.realName,
      idCard: this.idCard,
      caseFlow: this.caseFlow,
      taskCode: this.taskCode
    }
    this.getTaskList(data)
    this.getTaskStatus()
  },

  mounted() {
    this.$emit('setCurrentMenu', '全部任务')
  },

  methods: {
    getTaskStatus() {
      const vm = this
      const apiUrl = vm.homePath() + '/case-task/status-enum'
      vm.axios.get(apiUrl)
        .then((res) => {
          if (res.data.status === '000000') {
            const resdata = res.data.data
            vm.taskStatusList = resdata
          } else {
            vm.$alert(res.data.message, '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    taskStatusChange(val) {
      this.status = val
    },

    /**
     * 监听所属流程的选项变化事件（已废除）
     */
    processChange(val) {
      this.caseFlow = val
    },

    /**
     * 监听任务类型的选项变化事件
     */
    allTaskChange(val) {
      this.taskCode = val
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.limit + index + 1
    },

    /**
     * 子任务-列表
     */
    getTaskList(data) {
      const vm = this
      const apiUrl = vm.homePath() + '/case-task/list'
      vm.axios
        .get(apiUrl, { params: data })
        .then((response) => {
          const data = response.data
          if (data.status === '000000') {
            vm.loading = false
            vm.tableData = data.page
          } else {
            vm.$alert(data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => console.log(error))
    },

    search() {
      this.pageIndex = 1
      const data = {
        accessRole: this.accessRole,
        limit: this.limit,
        page: this.pageIndex,
        caseId: this.caseId,
        handler: this.handler,
        status: this.status,
        startTime: this.startTime,
        realName: this.realName,
        idCard: this.idCard,
        caseFlow: this.caseFlow,
        taskCode: this.taskCode
      }
      this.getTaskList(data)
    },

    rowClick(row, column, event) {
      const refsElTable = this.$refs.multipleTable
      const findRow = this.selectRows.find((c) => c.rowIndex === row.rowIndex)
      if (findRow) {
        refsElTable.toggleRowSelection(row, false)
        return
      }
      refsElTable.clearSelection()
      refsElTable.toggleRowSelection(row)
    },

    rowStyle({ row, rowIndex }) {
      Object.defineProperty(row, 'rowIndex', {
        value: rowIndex,
        writable: true,
        enumerable: false
      })
    },

    rowClassName({ row, rowIndex }) {
      let rowName = ''
      const findRow = this.selectRows.find((c) => c.rowIndex === row.rowIndex)
      if (findRow) {
        rowName = 'current-row '
      }
      return rowName
    },

    selectionChange(rows) {
      this.selectRows = rows
    },

    changeOperator(val) {
      this.currentCode = val.code
    },

    onSeeCase() {
      const vm = this
      if (vm.selectRows.length < 1) {
        vm.$alert('请选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      if (vm.selectRows.length > 1) {
        vm.$alert('只能选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      // 通过缓存“currentTaskSearchData”存储筛选条件内容
      // const currentTaskSearchData = {
      //   accessRole: vm.accessRole,
      //   limit: vm.limit,
      //   pageIndex: vm.pageIndex,
      //   caseId: vm.caseId,
      //   handler: vm.handler,
      //   status: vm.status,
      //   startTime: vm.startTime,
      //   realName: vm.realName,
      //   idCard: vm.idCard,
      //   caseFlow: vm.caseFlow,
      //   taskCode: vm.taskCode
      // }

      // localStorage.setItem(
      //   'currentTaskSearchData',
      //   JSON.stringify(currentTaskSearchData)
      // )
      this.$router.push({
        path: '/index/caseDetailV2/' + vm.selectRows[0].caseCode,
        query: {
          from: 'task',
          taskCode: vm.selectRows[0].taskCode,
          taskVersion: vm.selectRows[0].taskVersion
        }
      })
    },

    pageChange(val) {
      this.pageIndex = val
      const data = {
        accessRole: this.accessRole,
        limit: this.limit,
        page: this.pageIndex,
        caseId: this.caseId,
        handler: this.handler,
        status: this.status,
        startTime: this.startTime,
        realName: this.realName,
        idCard: this.idCard,
        caseFlow: this.caseFlow,
        taskCode: this.taskCode
      }
      this.getTaskList(data)
    },

    onChangeCase() {
      const vm = this
      if (vm.selectRows.length < 1) {
        vm.$alert('请选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }

      if (vm.selectRows.length > 1) {
        vm.$alert('只能选择一条记录', '提示', {
          confirmButtonText: '确定',
          type: 'warning'
        })
        return
      }
      const apiUrl = vm.homePath() + '/case-task/modify-user-list/' + vm.selectRows[0].taskCode
      vm.axios
        .get(apiUrl)
        .then((response) => {
          const data = response.data
          if (data.status === '000000') {
            vm.dialogData = vm.filterNull(vm.toTreeData(data.data, 'parentCode', 'code'))
            vm.dialogFormVisible = true
          } else {
            vm.$alert(data.message)
          }
        })
        .catch((error) => console.log(error))
    },

    save() {
      const postData = {
        taskCode: this.selectRows[0].taskCode,
        taskVersion: this.selectRows[0].taskVersion,
        userId: this.currentCode
      }

      const apiUrl = this.homePath() + '/case-task/modify-user'
      this.axios
        .post(apiUrl, postData)
        .then((response) => {
          this.dialogFormVisible = false
          if (response.data.status === '000000') {
            this.$alert('更改成功', '提示', {
              callback: () => {
                const data = {
                  accessRole: this.accessRole,
                  limit: this.limit,
                  page: this.pageIndex,
                  caseId: this.caseId,
                  handler: this.handler,
                  status: this.status,
                  startTime: this.startTime,
                  realName: this.realName,
                  idCard: this.idCard,
                  caseFlow: this.caseFlow,
                  taskCode: this.taskCode
                }
                this.getTaskList(data)
              }
            })
          } else {
            this.$alert(response.data.message)
          }
        })
        .catch((error) => console.log(error))
    },

    // /**
    //  * 导出案件
    //  */
    // exportCase() {
    //   window.location.href =
    //     this.homePath() +
    //     '/case-task/excelExport?realName=' +
    //     (this.realName == null ? '' : this.realName) +
    //     '&caseId=' +
    //     (this.caseId == null ? '' : this.caseId) +
    //     '&status=' +
    //     (this.status == null ? '' : this.status) +
    //     '&startTime=' +
    //     (this.startTime == null ? '' : this.startTime) +
    //     '&limit=' +
    //     (this.limit == null ? '' : this.limit) +
    //     '&page=' +
    //     (this.pageIndex == null ? '' : this.pageIndex) +
    //     '&caseFlow=' +
    //     (this.caseFlow == null ? '' : this.caseFlow) +
    //     '&taskCode=' +
    //     (this.taskCode == null ? '' : this.taskCode) +
    //     '&handler=' +
    //     (this.handler == null ? '' : this.handler) +
    //     '&accessRole=' +
    //     this.accessRole +
    //     '&time=' +
    //     new Date().valueOf()
    // },

    /**
     * 导出任务数据
     */
    async exportCase() {
      const vm = this;
      const homePath = vm.homePath();

      try {
        const data = {
          caseId: vm.caseId == null ? '' : vm.caseId, // 事件ID
          status: vm.status == null ? '' : vm.status, // 任务状态
          accessRole: vm.accessRole, // 全部案件/待办案件未传
          caseFlow: vm.caseFlow == null ? '' : vm.caseFlow,
          realName: vm.realName == null ? '' : vm.realName, // 受助人姓名
          startTime: vm.startTime == null ? '' : vm.startTime, // 任务分配时间
          taskCode: vm.taskCode == null ? '' : vm.taskCode, // 任务类型
          handler: vm.handler == null ? '' : vm.handler, // 处理人姓名
          exportType: 3, // 任务列表报表
        }
        const { data: result } = await vm.axios.post(`${homePath}/case-task/add`, {}, { params: data })
        if (result && result.status === "000000") {
          vm.fullscreenLoading = true;
          vm.checkExportTask(result.data);
        } else {
          vm.$alert(result && result.message);
        }
      } catch (error) {
        console.log("导出任务数据-请求失败", error);
      }
    },

    /**
     * 查询导出任务状态
     * @param {number} exportTaskId   导出任务id
     */
    async checkExportTask(exportTaskId = "") {
      const vm = this;
      const homePath = vm.homePath();

      try {
        const { data: result } = await vm.axios.get(
          `${homePath}/export-task/check/${exportTaskId}`
        );
        const newData = result && result.data;

        if (newData && Number(newData.exportStatus) === 0) {
          // 进行中
          setTimeout(() => {
            vm.checkExportTask(newData.exportTaskId);
          }, 5000);
        } else if (newData && Number(newData.exportStatus) === 1) {
          // 成功
          vm.fullscreenLoading = false;
          // 打开新页面
          window.location.href = newData.exportUrl;
        } else {
          vm.fullscreenLoading = false;
          // 失败
          vm.$alert(result && result.message);
        }
      } catch (error) {
        console.log("查询导出任务状态-请求失败", error);
      }
    },
  }
}
</script>

<style scoped>
.select-title {
  font-size: 14px;
  font-weight: 700;
}
.select-option li {
  float: left;
  margin: 10px;
}
.select-input {
  width: auto;
}
.el-table td,
.el-table th {
  padding: 6px 0px;
}
.el-table th {
  color: #333;
  font-weight: bold;
  text-align: center;
}
</style>
